import { PriceSummaryRow } from '@ps-design-system/components/PriceSummary';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const CreditsLineItem = ({ currency, totalCredits }) => {
  return (
    <PriceSummaryRow
      testId="applied-credits-line-item"
      name={(
        <FormattedMessage
          id="price_summary.credits"
          defaultMessage="Credits"
        />
      )}
      value={(
        <FormattedNumber
          value={-totalCredits}
          style="currency"
          currency={currency}
        />
      )}
      variant="highlight"
    />
  );
};
CreditsLineItem.displayName = 'CreditsLineItem';
CreditsLineItem.propTypes = {
  currency: PropTypes.string,
  totalCredits: PropTypes.number
};
